import { render, staticRenderFns } from "./ShortPayments.vue?vue&type=template&id=0bb48d28&scoped=true"
import script from "./ShortPayments.vue?vue&type=script&lang=js"
export * from "./ShortPayments.vue?vue&type=script&lang=js"
import style0 from "./ShortPayments.vue?vue&type=style&index=0&id=0bb48d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb48d28",
  null
  
)

export default component.exports